import { useNavigate } from "react-router-dom";
import styles from "./DesignBoxConfirmationRow.module.css";

const DesignBoxConfirmationRow = ({ item }) => {
  console.log(item, "confirmed Item");
  const navigate = useNavigate();
  return (
    <div className={styles.table_row}>
      <div className={styles.title}>{item?.product?.title}</div>
      <div className={styles.design_display}>
        <div>完成デザイン表示日</div>
        <div>{item?.design?.created_at}</div>
      </div>
      <div className={styles.change_acceptance}>
        <div>変更受付期限</div>
        <div>{item?.design?.change_deadline}</div>
      </div>
      <div className={styles.status}>
        {item?.button_button && (
          <button
            className={styles.row_button}
            onClick={() => {
              navigate("/design-box/" + item?.id, { state: { item: item } }); // It will render DesignConfirmationPreviewPage
            }}
          >
            {item?.button}
          </button>
        )}
        {!item?.button_button && <div>{item?.button}</div>}
      </div>
    </div>
  );
};
export default DesignBoxConfirmationRow;
